import styled from "styled-components";
import { Flex } from "antd";
import { Typography } from "antd";

// ─── Header Wrapper ───────────────────────────────────────────────────────────
// Extends AntD Flex so all Flex props (justify, align, flex, gap) still work.
// Only non-layout visual properties are defined here.

export const HeaderWrapperStyled = styled(Flex)`
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  flex-shrink: 0;
  position: relative;
  z-index: 1000;
`;

// ─── Header Title ─────────────────────────────────────────────────────────────
// Removes AntD Typography.Title default bottom margin.

export const HeaderTitleStyled = styled(Typography.Title)`
  && {
    margin: 0;
  }
`;
